import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IWalkthroughsService = ( createDecorator('walkthroughsService'));
export { IWalkthroughsService };
